// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"Ft-z","tooltipWrapper":"Gt-z","icon":"Ht-z","tooltip":"It-z","content":"Jt-z"};